import { CreativeTypeValue } from '../../../utils/consts';

export const MIXPANEL_INSIGHTS_EVENT = 'Creative Insights';
export const INSIGHTS_KEY_PREFIX = 'STATIC.PAGES.CREATIVE_INSIGHTS';
export const INSIGHTS_TAB = 'INSIGHTS';
export const URL_KEY = 'url';
export const MIN_DATE_RANGE_DAYS = 30;
export const CREATIVE_PREVIEW = 'Creative Preview';
export const CREATIVE_TYPE = 'Creative Type';
export const OS = 'OS';
export const CAMPAIGN_NAME = 'Campaign Name';
export const COUNTRY = 'Country';
export const COST = 'Cost';
export const IMPRESSIONS = 'Impressions';
export const CREATIVE_EFFICIENCY_SCORE = 'Creative Efficiency Score';
export const AGG_SUM = 'sum';
export const AGG_AVG = 'avg';

export const DEFAULT_COL_DEF = {
    sortable: true,
    resizable: true,
};

export const AUTO_GROUP_COLUMN_DEF = {
    minWidth: 200,
    headerName: 'Group',
    cellRendererParams: {
        suppressCount: false,
    },
};

export const Category = {
    TOP_BOTTOM_PERFORMING: 'top_and_bottom_performing_creatives',
    SINGLE_DIMENSION_ANALYSIS: 'single_dimension_analysis',
    HIGH_IMPACT_COMBINATION: 'high_impact_creative_combinations_analysis',
    SHARE_OF_VOICE: 'share_of_voice_analysis',
    CREATIVE_BRIEF: 'creative_brief',
    SUGGESTIONS: 'suggestions',
};

export const CategoryOrder = [
    Category.TOP_BOTTOM_PERFORMING,
    Category.SINGLE_DIMENSION_ANALYSIS,
    Category.HIGH_IMPACT_COMBINATION,
    Category.SHARE_OF_VOICE,
];

export const CategoryToTitle = {
    [Category.TOP_BOTTOM_PERFORMING]: 'Top And Bottom Performing Creatives',
    [Category.SINGLE_DIMENSION_ANALYSIS]: 'Single Dimension Analysis',
    [Category.HIGH_IMPACT_COMBINATION]: 'High Impact Creative Combinations Analysis',
    [Category.SHARE_OF_VOICE]: 'Share of Voice Analysis',
    [Category.CREATIVE_BRIEF]: 'Creative Brief',
    [Category.SUGGESTIONS]: 'Suggestions',
};

export const CategoryToIcon = {
    [Category.TOP_BOTTOM_PERFORMING]: 'photo-spark',
    [Category.SINGLE_DIMENSION_ANALYSIS]: 'input-spark',
    [Category.HIGH_IMPACT_COMBINATION]: 'columns',
    [Category.SHARE_OF_VOICE]: 'chart-pie',
};

export const CREATIVE_TYPES = [CreativeTypeValue.video, CreativeTypeValue.image];
